import template from './filtersList.template.html';

export default {
  template,
  bindings: {
    filters: '=',
    onEdit: '&',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listInstanceService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listInstanceService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.filters, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      ctrl.edit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };
      ctrl.click = ($event, data, isList) => {
        ctrl.onClick({ event: $event, data, isList });
      };
      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (changes.filters && changes.filters.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
